import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_URL } from "constants";

// Define the export-related API endpoints
export const exportApi = createApi({
  reducerPath: "exportApi",
  baseQuery: fetchBaseQuery({
    baseUrl: API_URL,
  }),
  tagTypes: ["ExportVideo", "ExportXml", "DownloadVideo"],
  endpoints: (builder) => ({
    exportVideo: builder.mutation({
      query: ({ projectId, sequence }) => ({
        url: `start_video_processing`,
        method: "POST",
        body: { project_id: projectId, sequence },
      }),
      transformResponse: (response) => {
        return {
          taskId: response.task_id,
          status: response.status,
        };
      },
    }),
    downloadVideo: builder.query({
      query: ({ projectId }) => ({
        url: `/download_video/${projectId}`,
        responseHandler: (response) => response.blob(),
      }),
    }),
    exportXml: builder.mutation({
      query: ({ projectId, sequence }) => ({
        url: `/project/${projectId}/export`,
        method: "POST",
        body: { exportList: sequence },
        responseHandler: "text",
      }),
    }),
  }),
});

export const {
  useExportVideoMutation,
  useDownloadVideoQuery,
  useExportXmlMutation,
} = exportApi;
export default exportApi;
